const replicarSolicitudState = {

  prestadorPuedeReplicar: false,
  usuarioPuedeReplicar: false,
  modalValidacion: false,

  loadingDetalleSolicitud: 0,
  modalSolicitudReplicada: false,
  idSolicitudReplicada: 0,

  detalleValidacionCentrosAtencion: [],
  idsPrestacionesHomologas: [],

  loadingValidacionSolicitudEnCurso: null,
  loadingValidacionCentrosAtencion: null,
  loadingValidacionIdsHomologos: null,
  loadingValidacionIdsHomologosAux: true,
};

export default replicarSolicitudState;




// WEBPACK FOOTER //
// ./src/components/Paquetes/ReplicarSolicitud/state.js